import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTimeZone, SetCreateUser } from "redux/UserManagement/action";
import {
  Col,
  DropdownBox,
  Label,
  Row,
  SwitchToggle,
  OutlineButton,
  PrimaryButton,
} from "../../../../../../CommonComponents";
import { InputField } from "../../../../../../CommonComponents";

interface IProps {
  userForm: any;
  userHandleChange: any;
  userFormError: any;
  handleClickSave: any;
  fetchUserByUpn?: any;
  divisionData?: any;
  costcenterDropdown?: any;
  setUserForm?: any;
  initialValues?: any;
  setUserFormError?: any;
  initialError?: any;
  selectedOption?: any;
}

const GeneralInformation = ({
  userForm,
  userHandleChange,
  userFormError,
  handleClickSave,
  fetchUserByUpn,
  divisionData,
  costcenterDropdown,
  setUserForm,
  initialValues,
  setUserFormError,
  initialError
}: IProps) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (userForm?.userId == 0) {
      setUserForm(initialValues)
      userForm.email = "";
      userForm.firstName = "";
      userForm.lastName = ""
      setUserForm(userForm)
      setUserFormError(initialError)
    }
    dispatch(SetCreateUser(0));
    dispatch(getTimeZone())
  }, [])

  const {
    timeZoneData
  }: any
    = useSelector(
      (state: any) => ({
        timeZoneData: state.UserManagement.timeZone
      })
    )

  return (

    <>
      <div className="app-grid-container">
        <div className="GeneralTabClass">
          <p className="profile">{userForm?.userId ? "Edit Employee User Information" : "Add New Employee User Information"} </p>
          <div className="GeneralTitleClass">
            <p className="TitleContentClass">General Information</p>
          </div>
          <div className="GeneralInfoClass">
            <Row className="mb-3">
              <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                <Label required data-attribute="GeneralInformation_Default_Label">User Principle Name (Azure AD)</Label>
                <InputField
                  name="email"
                  type="email"
                  placeholder="UPN"
                  value={userForm.email}
                  onChange={userHandleChange}
                  onBlur={fetchUserByUpn}
                  disabled={true}
                 data-attribute="GeneralInformation_email_Input" />
                {userFormError?.emailError ? (
                  <span className="asset-validation-msg">
                    {userFormError.emailError}
                  </span>
                ) : null}
              </Col>
              <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                <Label required data-attribute="GeneralInformation_Default_Label_2">First Name</Label>
                <InputField
                  name="firstName"
                  placeholder="First Name"
                  value={userForm.firstName}
                  onChange={userHandleChange}
                  disabled={true}
                 data-attribute="GeneralInformation_firstName_Input" />
                {userFormError?.firstNameError ? (
                  <span className="asset-validation-msg">
                    {userFormError.firstNameError}
                  </span>
                ) : null}
              </Col>
              <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                <Label required data-attribute="GeneralInformation_Default_Label_3">Last Name</Label>
                <InputField
                  name="lastName"
                  placeholder="Last Name"
                  value={userForm.lastName}
                  onChange={userHandleChange}
                  disabled={true}
                 data-attribute="GeneralInformation_lastName_Input" />
                {userFormError?.lastNameError ? (
                  <span className="asset-validation-msg">
                    {userFormError.lastNameError}
                  </span>
                ) : null}
              </Col>
              <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                <Label data-attribute="GeneralInformation_Default_Label_4">Job Title</Label>
                <InputField
                  name="jobTitle"
                  placeholder="Job Title"
                  value={userForm.jobTitle}
                  onChange={userHandleChange}
                  disabled={true}
                 data-attribute="GeneralInformation_jobTitle_Input" />
              </Col>
              <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                <Label required data-attribute="GeneralInformation_Default_Label_5">Employee ID</Label>
                <InputField
                  name="employeeId"
                  placeholder="Employee ID"
                  value={userForm.employeeId}
                  onChange={userHandleChange}
                  disabled={true}
                 data-attribute="GeneralInformation_employeeId_Input" />
                {userFormError?.employeeIdError ? (
                  <span className="asset-validation-msg">
                    {userFormError.employeeIdError}
                  </span>
                ) : null}
              </Col>
              <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                <Label required data-attribute="GeneralInformation_Default_Label_6">Default Company</Label>
                <DropdownBox
                  name="companyId"
                  placeholder="Select"
                  options={divisionData}
                  value={userForm.companyId}
                  onChange={userHandleChange}
                  selectedKey={userForm?.companyId?.toString()}
                  disabled={true}
                 data-attribute="GeneralInformation_companyId_Dropdown" />
                {userFormError?.companyIdError ? (
                  <span className="asset-validation-msg">
                    {userFormError.companyIdError}
                  </span>
                ) : null}
              </Col>
              <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                <Label required data-attribute="GeneralInformation_Default_Label_7">Home Cost Center</Label>
                <DropdownBox
                  name="costCenter"
                  placeholder="Select"
                  options={costcenterDropdown}
                  value={userForm.costCenter}
                  onChange={userHandleChange}
                  selectedKey={userForm?.costCenter?.toString()}
                  disabled={true}
                 data-attribute="GeneralInformation_costCenter_Dropdown" />
                {userFormError?.costCenterError ? (
                  <span className="asset-validation-msg">
                    {userFormError.costCenterError}
                  </span>
                ) : null}
              </Col>
            </Row>
          </div>
          <Row className="mb-3">
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
              <div className="ContactTitleClass">
                <p className="TitleContentClass">Contact Information</p>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
              <div className="timeZoneTitleClass">
                <p className="TitleContentClass">Time Zone</p>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
              <div className="NotificationTitleClass">
                <p className="TitleContentClass">Notification Preference</p>
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
              <div className="ContactInfoClass pt-3">
                <Row className="mb-3">
                  <Col className=" contactTab1 mb-3">
                    <Label data-attribute="GeneralInformation_Default_Label_8">Buisness Phone</Label>
                    <InputField
                      name="phone"
                      placeholder="Buisness Phone"
                      onChange={userHandleChange}
                      value={userForm.phone}
                      disabled={true}
                     data-attribute="GeneralInformation_phone_Input" />
                  </Col>
                  <Col className=" contactTab1 mb-3">
                    <Label data-attribute="GeneralInformation_Default_Label_9">EXT</Label>
                    <InputField
                      name="extn"
                      placeholder="EXT"
                      onChange={userHandleChange}
                      value={userForm.extn}
                      disabled={true}
                     data-attribute="GeneralInformation_extn_Input" />
                  </Col>
                  <Col className=" contactTab1 mb-3">
                    <Label data-attribute="GeneralInformation_Default_Label_10">Fax</Label>
                    <InputField
                      name="fax"
                      placeholder="Fax"
                      onChange={userHandleChange}
                      value={userForm.fax}
                      disabled={true}
                     data-attribute="GeneralInformation_fax_Input" />
                  </Col>
                  <Col className="contactTab1 mb-3">
                    <Label data-attribute="GeneralInformation_Default_Label_11">Mobile</Label>
                    <InputField
                      name="mobile"
                      placeholder="Mobile"
                      onChange={userHandleChange}
                      value={userForm.mobile}
                      disabled={true}
                     data-attribute="GeneralInformation_mobile_Input" />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
              <div className="timeZoneClass pt-3">
                <Row className="mb-3">
                  <Col className=" timeZone1 mb-3">
                    <Label data-attribute="GeneralInformation_Default_Label_12">Time Zone</Label>
                    <DropdownBox
                      name="timeZoneId"
                      placeholder="Select"
                      options={timeZoneData}
                      onChange={userHandleChange}
                      value={userForm.timeZoneId}
                      selectedKey={userForm?.timeZoneId?.toString()}
                      disabled={true}
                     data-attribute="GeneralInformation_timeZoneId_Dropdown" />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
              <div className="NotificationClass pt-3">
                <Row className="mb-3">
                  <Col className=" notificationPref1 mb-3">
                    <Label data-attribute="GeneralInformation_Default_Label_13">Email Notification</Label>
                    <SwitchToggle
                      className="emailToggleClass"
                      name="emailNotification"
                      defaultChecked={true}
                      onChange={userHandleChange}
                      disabled={true}
                     data-attribute="GeneralInformation_emailNotification_SwitchToggle" />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <div>
            <div className="pull-left activeToggle">
              <SwitchToggle
                className=""
                name="isActive"
                defaultChecked={true}
                onChange={userHandleChange}
                disabled={true}
               data-attribute="GeneralInformation_isActive_SwitchToggle" />
              <Label className="activeLabel" data-attribute="GeneralInformation_Default_Label_14">Active</Label>
            </div>
            <div className="pull-right btnClass">
              <PrimaryButton
                text="Save"
                className="pull-right "
                onClick={handleClickSave}
                disabled={true}
               data-attribute="GeneralInformation_Default_Button" />
              <OutlineButton disabled={true} text="Cancel" className="pull-right me-1"  data-attribute="GeneralInformation_Default_Button_2" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralInformation;
